import { render, staticRenderFns } from "./DatabaseSync.vue?vue&type=template&id=7cc11ac6"
import script from "./DatabaseSync.vue?vue&type=script&lang=js"
export * from "./DatabaseSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports